import React from 'react'
import { Link } from 'react-router-dom'
import * as S from './List.styled'
import type { ListProps } from './types'
import { Loader } from '../Loader'
import { Loading } from '../Loading'

export const List = ({
  data,
  isLoading,
  emptyComponent,
  locationState,
  topBorder = true,
  bottomBorder = true,
  renderItem,
  getItemLink,
  getItemHighlighted,
  onClick,
}: ListProps) => {
  if (data.length === 0) {
    if (isLoading)
      return (
        <S.StateContainer>
          <Loader />
        </S.StateContainer>
      )

    if (emptyComponent) {
      return <S.StateContainer>{emptyComponent}</S.StateContainer>
    }

    return null
  }

  return (
    <Loading isLoading={isLoading}>
      <S.Container>
        {data.map((item, index) => (
          <S.ListItem
            data-testid="ListItem"
            key={typeof item === 'object' && 'id' in item ? item.id : index}
            as={getItemLink ? Link : 'div'}
            to={getItemLink && getItemLink(item)}
            state={locationState}
            $topBorder={topBorder}
            $bottomBorder={bottomBorder}
            $highlighted={getItemHighlighted && getItemHighlighted(item)}
            onClick={onClick && (() => onClick(item, index))}
          >
            {renderItem(item, index)}
          </S.ListItem>
        ))}
      </S.Container>
    </Loading>
  )
}
